export enum UnspecifiedKeysEnum {
    UnspecifiedKey = 'UNS',
    UnspecifiedDocumentKey = 'UNS',
    UnspecifiedAccountsKey = 'UNS',
    UnspecifiedGroupsKey = 'UNS',
    UnspecifiedExecutionTypeKey = 'UNS',
    UnspecifiedPortalIdKey = 'UNS',
    UnspecifiedCurrencyKey = 'UNS',
}
